import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Pizzas from '../views/Pizzas.vue'
import Chicken from '../views/Chicken.vue'
import Brunch from '../views/Brunch.vue'
import Other from '../views/Other.vue'
import Pricing from '../views/Pricing.vue'
import PricingDelivery from '../views/PricingDelivery.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Pizzeria Taberna' }
  },
  {
    path: '/pizze',
    name: 'Pizzas',
    component: Pizzas,
    meta: { title: 'Pizze' }
  },
  {
    path: '/slovenski-piscanec',
    name: 'Chicken',
    component: Chicken,
    meta: { title: 'Slovenski piščanec' }
  },
  {
    path: '/malice',
    name: 'Brunch',
    component: Brunch,
    meta: { title: 'Malice' }
  },
  {
    path: '/ostale-jedi',
    name: 'Other',
    component: Other,
    meta: { title: 'Ostale jedi' }
  },
  {
    path: '/cenik',
    name: 'Pricing',
    component: Pricing,
    meta: { title: 'Cenik' }
  },
  {
    path: '/cenik-za-dostavo',
    name: 'PricingDelivery',
    component: PricingDelivery,
    meta: { title: 'Cenik za dostavo' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
}
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  next()
});


export default router
